import api from '../../api'

const user = {
    state: {
        userInfo:{}
    },
    mutations: {
        SET_USER_INFO: (state, item) => {
          state.userInfo = item
        },

    }

}
export default user



